import type {
  MassTort,
  MassTortNoteWithComments,
  MassTortTaskWithComments,
  Matter,
  MatterNoteWithComments,
  MatterTaskWithComments,
} from "@/lib/types";

export const getMassTortAnnotationMatter = (massTort?: MassTort): Matter => {
  const massTortId = massTort?.id.trim() ?? "";

  return {
    id: massTortId,
    title: massTort?.title ?? "",
    summary: massTort?.description ?? "",
    eventLogs: massTort?.eventLogs ?? [],
    notes: massTort?.notes ?? [],
    noteComments: massTort?.noteComments ?? [],
    tasks: massTort?.tasks ?? [],
    taskComments: massTort?.taskComments ?? [],
    userConnections: [],
    assignees: [],
  } as unknown as Matter;
};

export const getMassTortAnnotationNotes = (
  notes: MassTortNoteWithComments[],
): MatterNoteWithComments[] =>
  notes.map((note) => ({
    ...note,
    matterId: note.matterId ?? "",
    comments: note.comments.map((comment) => ({
      ...comment,
      matterId: comment.matterId ?? "",
    })),
  }));

export const getMassTortAnnotationTasks = (
  tasks: MassTortTaskWithComments[],
): MatterTaskWithComments[] =>
  tasks.map((task) => ({
    ...task,
    matterId: task.matterId ?? "",
    comments: task.comments.map((comment) => ({
      ...comment,
      matterId: comment.matterId ?? "",
    })),
  }));
